import portal from "portalConfig"
import { DateTime } from "luxon"

export const calendarDateRange = () => {
  const minDate = DateTime.now().plus({
    days: portal.config.parkingSession.startOffsetDate
  })
  const maxDate = DateTime.now().plus({
    days: portal.config.parkingSession.endOffsetDate
  })

  return { minDate, maxDate }
}
